// Robust mock-data og statisk indhold til Ecolaser ApS

export const navigation = {
  menu: [
    { label: "Forside", href: "/" },
    {
      label: "Ydelser",
      href: "/ydelser",
      children: [
        { label: "Fredede & bevaringsværdige bygninger", href: "/ydelser/fredede-bygninger" },
        { label: "Facaderens & murværk", href: "/ydelser/facaderens-murvaerk" },
        { label: "Graffiti, beton & natursten", href: "/ydelser/graffiti-beton-natursten" },
        { label: "Industri & skadeservice", href: "/ydelser/industri-skadeservice" },
        { label: "Rust & metaloverflader", href: "/ydelser/rust-metaloverflader" },
        { label: "Priser", href: "/priser" }
      ]
    },
    { label: "Om os", href: "/om-os" },
    { label: "Medieomtale", href: "/medieomtale" },
    { label: "FAQ", href: "/faq" },
    { label: "Galleri", href: "/galleri" },
    { label: "Før / Efter", href: "/foer-efter" },
    { label: "Cases", href: "/cases" },
    { label: "Kontakt", href: "/kontakt" }
  ]
};

export const contactInfo = {
  company: "Ecolaser ApS",
  address: "Kirkevej 16, 8550 Ryomgård",
  phone: "29100810",
  email: "info@ecolaser.dk",
  hours: [
    { days: "Man - Fre", time: "08:00 - 17:00" },
    { days: "Lørdag", time: "09:00 - 13:00" },
    { days: "Søndag", time: "Lukket" }
  ]
};

export const usps = [
  {
    id: "kemifri",
    title: "Kemifri & vandfri rensning",
    description: "100% kemifri og tør proces helt uden brug af kemikalier, syre eller vand. Da vi ikke bruger vand, er laserrens unik til afrensning indenfor uden risiko for fugtskader.",
    icon: "fa-regular fa-droplet-slash"
  },
  {
    id: "skaansom",
    title: "Skånsom behandling",
    description: "Ingen mekanisk slid eller slibning. Det underliggende materiale efterlades 100% uberørt.",
    icon: "fa-regular fa-sparkles"
  },
  {
    id: "bevarer",
    title: "Bevarer originale materialer",
    description: "Perfekt til sarte overflader og historisk kulturarv, hvor den originale struktur og patina skal bevares.",
    icon: "fa-regular fa-shield-check"
  },
  {
    id: "landsdaekkende",
    title: "Landsdækkende service",
    description: "Vi dækker hele Danmark med vores mobile udstyr, uanset om det er Jylland, Fyn eller Sjælland.",
    icon: "fa-regular fa-map-location-dot"
  },
  {
    id: "teknologi",
    title: "Moderne laserteknologi",
    description: "Vi anvender udelukkende professionelt, CE-godkendt udstyr for maksimal driftssikkerhed og præcision.",
    icon: "fa-regular fa-microchip"
  },
  {
    id: "responstid",
    title: "Hurtig responstid",
    description: "Ingen tørretid eller svineri. Overfladen er klar til brug eller efterbehandling med det samme.",
    icon: "fa-regular fa-bolt"
  }
];

export const services = [
  {
    slug: "fredede-bygninger",
    title: "Laserrensning af fredede og bevaringsværdige bygninger",
    icon: "fa-solid fa-landmark",
    image: "https://assets.auxodev.dk/assets/9272dfda-3124-4579-9ee4-d6842e5967c6/front-kbh-chr-d-9-high.webp",
    short_desc: "Specialiseret laserafrensning af fredede og historiske ejendomme med dyb respekt for vores fælles kulturarv.",
    weight: 1,
    advantages: [
      "Ultrapræcis styring af lysstrålen, tilpasset sarte og historiske materialer",
      "Fjerner overfladesnavs, sod og sekundære belægninger helt uden fysisk berøring",
      "Bevarer materialets oprindelige overfladestruktur og historiske patina intakt",
      "Renser effektivt helt i bunden af komplekse ornamentikker, stuk og friser"
    ],
    process: [
      "Dybdegående analyse af de historiske materialers sårbarhed",
      "Etablering af kontrolleret laserzone og sikkerhedsafskærmning",
      "Nænsom, berøringsfri afrensning af sod, skidt eller graffiti",
      "Fælles besigtigelse og godkendelse af det bevarede resultat"
    ]
  },
  {
    slug: "facaderens-murvaerk",
    title: "Facaderens med laser til murværk og byggeri",
    icon: "fa-solid fa-trowel-bricks",
    image: "https://assets.auxodev.dk/assets/9272dfda-3124-4579-9ee4-d6842e5967c6/img-20260514-075654.jpg",
    short_desc: "Specialiseret facaderens med laser og laserafrensning af nybyggeri og ældre ejendomme. Målrettet fjernelse af salpeterudtræk, kalkslør og smuds.",
    weight: 2,
    advantages: [
      "Fjerner effektivt salpeterudtræk, kalkaflejringer og hvidt slør",
      "Ingen tilførsel af vand til murstenens kapillarer – eliminerer risiko for frostskader",
      "Helt fri for kemi og syre, hvilket beskytter både sten og fuger",
      "Bevarer murstenens vitale brandhud og oprindelige struktur intakt"
    ],
    process: [
      "Kortlægning af murværkets tilstand og brændingsgrad",
      "Præcis kalibrering af laseren efter overfladens hårdhed",
      "Skånsom afrensning af salpeter, kalk eller sod",
      "Slutkontrol og aflevering af den tørre, rene facade"
    ]
  },
  {
    slug: "graffiti-beton-natursten",
    title: "Graffiti, beton & natursten",
    icon: "fa-solid fa-spray-can",
    image: "https://assets.auxodev.dk/assets/9272dfda-3124-4579-9ee4-d6842e5967c6/graffiti-1x1-for-granit.jpg",
    short_desc: "Effektiv fjernelse af uønsket graffiti, gamle belægninger og graffitirester på rå beton, granit og sarte natursten.",
    weight: 3,
    advantages: [
      "Fjerner målrettet graffiti og tags uden at skade den underliggende overfladestruktur",
      "Ingen brug af kemikalier, syre eller vand – ingen risiko for frostskader i beton",
      "Sublim til rå, porøse betonoverflader og hårdfør granit",
      "Ekstremt skånsom over for sarte natursten som f.eks. sandsten og marmor"
    ],
    process: [
      "Identifikation af graffititype og underlagets beskaffenhed",
      "Indstilling af laserens parametre for optimal graffitinedbrydning",
      "Præcis afrensning af graffiti uden at efterlade skygger eller mærker",
      "Opsugning af det forstøvede restprodukt via HEPA-udsugning"
    ]
  },
  {
    slug: "industri-skadeservice",
    title: "Laserrens til industri og skadeservice med præcis kontrol",
    icon: "fa-solid fa-industry",
    image: "https://assets.auxodev.dk/assets/9272dfda-3124-4579-9ee4-d6842e5967c6/rampe-med-maling-1-1024x923.jpg",
    short_desc: "Specialiseret og mobil laserrens til industri, procesudstyr og skadeservice i hele Danmark. 100% vandfri, kemifri og skånsom proces.",
    weight: 4,
    advantages: [
      "Helt unik til indendørs afrensning, da processen er 100% vandfri",
      "Rengøring af procesudstyr og støbeforme helt uden mekanisk slid på formenes geometrier",
      "Yderst effektiv sodsanering efter brand uden at vaske giftige partikler dybere ind i muren",
      "Komplet og hurtig fjernelse af skimmelsvamp og sundhedsskadelige sporer"
    ],
    process: [
      "Akut vurdering af skadens omfang eller udstyrets geometri",
      "Opsætning af mobilt udstyr (kan tages med på lifte og stilladser)",
      "Hurtig og tør afrensning af sod, fedt eller skimmelsvamp",
      "Direkte opsugning og filtrering af restpartikler via HEPA-filtre"
    ]
  },
  {
    slug: "rust-metaloverflader",
    title: "Rust & metaloverflader",
    icon: "fa-solid fa-screwdriver-wrench",
    image: "https://assets.auxodev.dk/assets/9272dfda-3124-4579-9ee4-d6842e5967c6/metal-rust-800-x-800-px-4.jpg",
    short_desc: "Ultrapræcis fjernelse af rust, oxidering og korrosion på alle typer metaller uden mekanisk eller termisk påvirkning.",
    weight: 5,
    advantages: [
      "Laserstrålen reagerer kun på rusten og stopper ved mødet med grundmaterialet",
      "Bevarer metallets oprindelige tolerancer, geometrier og overfladestruktur 100% intakt",
      "Efterlader en fuldstændig kemisk ren overflade, klar til efterbehandling",
      "Ingen brug af sandblæsning, kemi eller fysisk slid på metallet"
    ],
    process: [
      "Vurdering af rustlagets tykkelse og metallets type",
      "Kalibrering af laserens energioutput og frekvens",
      "Berøringsfri fjernelse af rust, oxidlag eller graffiti",
      "Overlevering af det rene emne, klar til lakering eller svejsning"
    ]
  }
];

export const workProcess = [
  {
    step: "01",
    title: "Kontakt",
    description: "Du kontakter os via telefon, e-mail eller vores kontaktformular og beskriver din opgave."
  },
  {
    step: "02",
    title: "Gennemgang",
    description: "Vi foretager en grundig kortlægning af materialets tilstand og kemiske sammensætning."
  },
  {
    step: "03",
    title: "Tilbud",
    description: "Vi udarbejder et skræddersyet og uforpligtende tilbud med en estimeret pris og tidsplan."
  },
  {
    step: "04",
    title: "Udførelse",
    description: "Vi udfører laserrensningen på stedet med vores mobile, CE-godkendte udstyr."
  },
  {
    step: "05",
    title: "Aflevering",
    description: "Vi gennemgår det færdige resultat sammen med dig for at sikre, at du er 100% tilfreds."
  }
];

export const partners = [
  "Wicotec Kirkebjerg A/S",
  "Aarsleff Rail A/S",
  "Goldschmidt Holding A/S",
  "Arla Foods amba",
  "Jorton A/S",
  "HHM A/S",
  "Preben Poulsen Entreprenørfirma ApS"
];

export const fallbackMediaMentions = [
  {
    id: "dsb-stationer-detaljer",
    title: "Laser bringer stationernes historiske detaljer frem",
    source: "DSB Ejendomme",
    description: "På Sorø Station og Københavns Hovedbanegård har ECOLASER brugt laserteknologi til at fjerne mange års sod og snavs. Læs artiklen hos DSB Ejendomme om, hvordan metoden nænsomt bringer farver og detaljer frem igen med respekt for de historiske materialer.",
    url: "https://dsbejendomme.dk/nyheder/laserrens-paa-stationer/",
    button_text: "Læs artiklen hos DSB Ejendomme",
    weight: 1
  },
  {
    id: "linkedin-sandstensfigurer",
    title: "Afrensning af sandstensfigurerne på København",
    source: "LinkedIn",
    description: "Se omtalen af arbejdet med afrensning af sandstensfigurer og få et indblik i et af de projekter, hvor ECOLASERs arbejde er blevet fremhævet.",
    url: "https://www.linkedin.com/posts/s%C3%A5dan-afrenser-vi-sandstensfigurerne-p%C3%A5-k%C3%B8benhavn-ugcPost-7473351654696902656-Y5n0/",
    button_text: "Se opslag på LinkedIn",
    weight: 2
  },
  {
    id: "smvdanmark-forsikring",
    title: "SMVforsikring ændrede Pouls skepsis over for forsikringsbranchen",
    source: "SMVdanmark",
    description: "Læs artiklen hos SMVdanmark, hvor Poul fortæller om sine erfaringer med SMVforsikring og en grundig gennemgang af virksomhedens forsikringsforhold.",
    url: "https://smvdanmark.dk/seneste-nyt/nyheder/smv-nyheder/smvforsikring-%C3%A6ndrede-pouls-skepsis-over-for-forsikringsbranchen-jeg-har-ikke-oplevet-s%C3%A5-grundig-en-gennemgang-hos-andre-forsikringsselskaber",
    button_text: "Læs artiklen hos SMVdanmark",
    weight: 3
  }
];
